module.exports = __webpack_public_path__ + "media/preview_drum.3554d946.mp4";